<!-- Navbar Section -->
<nav class="navbar navbar-light bg-light app-header border-bottom">
  <div class="container d-flex justify-content-between align-items-center">
    <a href="https://gooddogkh.com" target="_blank" rel="noopener" class="navbar-brand">
      <img
        src="assets/img/brand/coco-pet-resort-long.png"
        class="img-fluid"
        style="max-height: 50px; width: auto;"
        title="CoCo Pet Logo"
      />
    </a>

    <ul class="navbar-nav flex-row align-items-center">
      <li *ngFor="let language of supportedLanguages" class="nav-item ms-2">
        <a class="nav-link p-0" (click)="changeLanguage(language)" style="cursor: pointer;">
          <img
            src="assets/img/flags/4x3/{{language}}.svg"
            alt="Flag"
            style="width: 30px; height: auto;"
          />
        </a>
      </li>
    </ul>
  </div>
</nav>

<!-- Main Form Section -->
<div class="bg-light min-vh-100 py-4">
  <c-container>
    <c-row class="justify-content-center">
      <!-- Changed sm="9" to responsive sizes for mobile (12) and desktop (8) -->
      <c-col xs="12" md="10" lg="8">
        <c-card class="shadow-sm border-0">
          <c-card-body class="p-3 p-md-4">
            <form cForm [formGroup]="pickUpBookingForm" (ngSubmit)="onSubmit()">
              <div class="mb-3">
                <h1 class="h3">{{ "PICK_UP_BOOKING.TITLE" | translate }}</h1>
                <p class="text-medium-emphasis">{{ "PICK_UP_BOOKING.SUB_TITLE" | translate }}</p>
              </div>

              <c-card class="mb-4 bg-transparent border-0">
                <c-card-body class="p-0">

                  <!-- First & Last Name: Splits into 2 columns on Medium screens and up -->
                  <c-row class="mb-3">
                    <c-col md="6" class="mb-3 mb-md-0">
                      <label cLabel for="firstName">{{ "FIRST_NAME" | translate }}</label>
                      <input cFormControl formControlName="firstName" id="firstName" type="text" />
                    </c-col>
                    <c-col md="6">
                      <label cLabel for="lastName">{{ "LAST_NAME" | translate }}</label>
                      <input cFormControl formControlName="lastName" id="lastName" type="text" />
                    </c-col>
                  </c-row>

                  <!-- Phone, Date, Time: Splits into 3 columns on Medium screens and up -->
                  <c-row class="mb-3">
                    <c-col md="4" class="mb-3 mb-md-0">
                      <label cLabel for="phone">{{ "PHONE" | translate }}</label>
                      <input cFormControl formControlName="phone" id="phone" type="text" />
                    </c-col>
                    <c-col md="4" class="mb-3 mb-md-0">
                      <label cLabel for="date">{{ "DATE" | translate }}</label>
                      <input cFormControl formControlName="date" id="date" type="date" />
                    </c-col>
                    <c-col md="4">
                      <label cLabel for="time">{{ "TIME" | translate }}</label>
                      <input cFormControl formControlName="time" id="time" type="time" step="3600" />
                    </c-col>
                  </c-row>

                  <!-- Address: Full Width -->
                  <c-row class="mb-4">
                    <c-col xs="12">
                      <label cLabel for="address">{{ "ADDRESS" | translate }}</label>
                      <input cFormControl formControlName="address" id="address" type="text" />
                    </c-col>
                  </c-row>

                </c-card-body>
              </c-card>

              <!-- Responsive Button -->
              <div class="d-grid">
                <button cButton color="primary" type="submit" size="lg" [disabled]="isBookingPickUp">
                  <span *ngIf="isBookingPickUp" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{ "SUBMIT" | translate }}
                </button>
              </div>

            </form>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
  </c-container>
</div>
